export enum Permissions {
  DashboardModule,
		ImportsModule,
		StockItemsModule,
		RequisitionCreate,
		ProcurementApproval,
		RequisitionApproval,
		StockRequisition,
		Admin,
		SuperAdmin, OrganisationList, OrganisationView, OrganisationManage, OrganisationRolesManage, UserAdvancedView,
		UserAdvancedManage,
		StockItemsModuleEdit,
		ImsModule,
		EMSView,
		EMSManage,
		RequisitionJobManagement,
		InvoicingModule,
		InvoicingEdit,
		JSEModule,
		StockItemsModuleView,
		CreateStoreRequisition,
		ProcurementAdmin,
		SupplierEdit,
		SupplierManageDocuments,
		ViewAllApprovedProcurement,
		ReqViewAllSuppliersOnStockItem,
		CatalogViewPrices,
		SupplierDocumentsReport,
		DetailedItemReport,
		OutstandingItemsReport,
		ViewDetailedWIPReport,
		InvoiceViewPermission,
		LargeReqAdminApproval,
		TenderRegister,
		ScaffoldMaterialRequestAdmin,
		ScaffoldMaterialRequestOfficer,
		ScaffoldMaterialRequestor,
		ScaffoldMaterialRequestModule,
		ScaffoldMaterialRequestApprover,
		ScaffoldMaterialRequestReports,

		CAPEX_Module,
		CAPEX_CapexRequestor,
		CAPEX_DisposalRequestor,
		CAPEX_CEO,
		CAPEX_FD,
		CAPEX_FM,
		CAPEX_MD,
		CAPEX_Board,
		CAPEX_ClosedOff,
		CAPEX_OrderPlaced,
		CAPEX_OrderReceived,
		CAPEX_Shareholders,
		CAPEX_Admin,
		CAPEX_DivisionReports,
		CAPEX_GlobalReports,
		CAPEX_FinanceNotification,
		SiteAdmin,
		EMSReports,
		ProcurementRequisitionsApprovalDailyReport,
		CAPEX_ReceiveDocuments,
		SPS_Module,
		SPS_View,
		SPS_Edit,
		SPS_Admin,
		SPS_Lookups,
		ProcurementBranchApprover,
		ProcurementBranchAdmin,
		ProcurementFMApproval,
		ProcurementFDApproval,
		TenderRegisterReports,
		ProcurementManager,
		ProcurementOperationsDirector,
		ProcurementNonJobApproval,
		ViewCreditors,
		EditCreditors,
		EstimatorApprover,
		StoreReqApprover,


		Mqs_CreateLead,
		Mqs_CreateQuoteEnquiry,
		Mqs_CreateJobCard,
		Mqs_View,
		Mqs_Reports,
		Mqs_ProjectProgress,
		Mqs_ManageLookups,
		Mqs_DocumentUploader,
		Mqs_CustomerSurvey,
		Mqs_ViewAll,
		Mqs_ManageSerialRegister,
		Mqs_ViewSerialRegister,
		Mqs_ViewAllRental,
		ProcurementAssistantFMApproval,
		ProcurementApprovalOther,
		ProcurementRentalApproval,
  InvoicingReports,
  Kpi_Reports,
  Kpi_Capture,
  Kpi_Admin,
  SalesDashboard,
  SalesDashboardConfig,
  ProcurementDivisionDirector,
  ProcurementFinanceManager,
  CAPEX_Admin_Setup,
  UserModulesVisited,
  ContractManagerAdministration
}
